(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 6863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "kI": function() { return /* binding */ StoreValue; },
/* harmony export */   "sr": function() { return /* binding */ Key; }
/* harmony export */ });
/* unused harmony exports KEYCHAIN_SERVICE_SUFFIX, remove, set */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);
/* harmony import */ var src_state_lib_observe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30033);
/* harmony import */ var src_constants_Environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30695);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var KEYCHAIN_SERVICE_SUFFIX = src_constants_Environment__WEBPACK_IMPORTED_MODULE_3__/* .EnvironmentManifest.API_ENV */ .S.API_ENV === 'production' ? '' : '-' + src_constants_Environment__WEBPACK_IMPORTED_MODULE_3__/* .EnvironmentManifest.API_ENV */ .S.API_ENV;
var KEYCHAIN_SERVICE = 'oneshop' + KEYCHAIN_SERVICE_SUFFIX;
var Key;

(function (Key) {
  Key["BusinessManagerId"] = "x-sp-bm-id";
  Key["BusinessId"] = "x-sp-b-id";
  Key["BusinessManagerToken"] = "x-sp-bm-token";
  Key["IdentitySessionToken"] = "x-sp-id-session-token";
})(Key || (Key = {}));

var StoreValue = src_state_lib_observe__WEBPACK_IMPORTED_MODULE_2__/* .Value */ .B4({});
var get = function get(keys) {
  var res = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    res[key] = js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(key);
  }

  StoreValue.transform(function (current) {
    var update = _objectSpread(_objectSpread({}, current), res);

    return update;
  });
  return res;
};
var remove = function remove(keys) {
  keys.map(function (key) {
    return Cookie.remove(key);
  });
  StoreValue.transform(function (current) {
    var update = _objectSpread({}, current);

    keys.forEach(function (key) {
      delete update[key];
    });
    return update;
  });
};
var set = function set(partialStore) {
  for (var key in partialStore) {
    var _partialStore;

    Cookie.set(key, (_partialStore = partialStore[key]) !== null && _partialStore !== void 0 ? _partialStore : '');
  }

  StoreValue.transform(function (current) {
    return _objectSpread(_objectSpread({}, current), partialStore);
  });
};

/***/ }),

/***/ 71862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22120);
/* harmony import */ var src_components_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71605);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


var _excluded = ["type", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var HIT_SLOP = {
  top: 12,
  bottom: 12,
  left: 0,
  right: 0
};

var Button = function Button(props) {
  var type = props.type,
      children = props.children,
      touchableOpacityProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);

  var disabled = Boolean(props.disabled);
  var style = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function () {
    return [type !== 'link' && buttonStyles.paddedRoot, buttonStyles[type], disabled && buttonStyles.disabled, touchableOpacityProps.style, props.asCircle && buttonStyles.circular, props.style];
  }, [type, disabled, props.style]);

  var textEl = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    style: [src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.T12M */ .pn.T12M, buttonTextStyles[type], props.textStyle],
    children: children
  });

  if (props.onPress != null) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default()), _objectSpread(_objectSpread({
      disabled: disabled,
      hitSlop: HIT_SLOP
    }, touchableOpacityProps), {}, {
      style: style,
      children: [props.leftAdornment, textEl, props.rightAdornment]
    }));
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7___default()), {
      style: style,
      children: [props.leftAdornment, textEl, props.rightAdornment]
    });
  }
};

var buttonStyles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default().create({
  paddedRoot: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 2 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit,
    height: 6 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit,
    borderRadius: 3 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit
  },
  primary: {
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .BrandColor.Bolt */ .Te.Bolt
  },
  secondary: {
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .BrandColor.BackgroundGray */ .Te.BackgroundGray
  },
  danger: {
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .BrandColor.BackgroundGray */ .Te.BackgroundGray
  },
  disabled: {
    opacity: 0.5
  },
  circular: {
    paddingHorizontal: 0,
    width: 6 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit
  },
  link: {}
});
var buttonTextStyles = {
  primary: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CWhite */ .pn.CWhite,
  secondary: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CMidnight */ .pn.CMidnight,
  danger: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CAccentRed */ .pn.CAccentRed,
  link: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CPositive */ .pn.CPositive
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 6692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "h_": function() { return /* binding */ Portal; },
/* harmony export */   "uT": function() { return /* binding */ Body; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16835);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22120);
/* harmony import */ var src_components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66001);
/* harmony import */ var src_components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71862);
/* harmony import */ var src_components_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71605);
/* harmony import */ var src_components_Portal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39538);
/* harmony import */ var react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89009);
/* harmony import */ var react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_native_web_dist_cjs_exports_Image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94965);
/* harmony import */ var react_native_web_dist_cjs_exports_Image__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Image__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);

















var Body = function Body(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* .EdgeGutter */ .MX, {
    style: styles.bodyRoot,
    children: props.children
  });
};
var Header = function Header(props) {
  var _props$nextLabel;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(false),
      _React$useState2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_React$useState, 2),
      nextLoading = _React$useState2[0],
      setNextLoading = _React$useState2[1];

  var backImageSource = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function () {
    return {
      uri: '/static/images/app/navigation-back.png',
      width: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(24),
      height: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(24)
    };
  }, []);
  var onNext = react__WEBPACK_IMPORTED_MODULE_1__.useCallback( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(props.onNext != null)) {
              _context.next = 12;
              break;
            }

            setNextLoading(true);
            _context.prev = 2;
            _context.next = 5;
            return props.onNext();

          case 5:
            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);

          case 9:
            _context.prev = 9;
            setNextLoading(false);
            return _context.finish(9);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7, 9, 12]]);
  })), [props.onNext]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(src_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* .EdgeGutter */ .MX, {
      style: styles.navigationRow,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_10___default()), {
        onPress: props.onBack,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((react_native_web_dist_cjs_exports_Image__WEBPACK_IMPORTED_MODULE_11___default()), {
          source: backImageSource,
          width: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(24),
          height: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(24),
          style: imageStyles.backIcon,
          resizeMode: "contain"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        disabled: nextLoading || props.nextDisabled,
        type: "primary",
        onPress: onNext,
        leftAdornment: nextLoading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_12___default()), {
          size: "small",
          style: styles.leftAdornment
        }) : undefined,
        children: (_props$nextLabel = props.nextLabel) !== null && _props$nextLabel !== void 0 ? _props$nextLabel : 'Next'
      })]
    }), props.errorLabel != null ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* .EdgeGutter */ .MX, {
      style: styles.errorContainer,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CWhite */ .pn.CWhite],
        children: props.errorLabel
      })
    }) : null]
  });
};
var Portal = function Portal(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(src_components_Portal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    id: "modal-card",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13___default()), {
      style: styles.background
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_13___default()), {
      style: [styles.root, props.style],
      children: props.children
    })]
  });
};
var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_14___default().create({
  background: {
    // @ts-ignore: (RNW CSS)
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 999,
    width: '100%',
    height: '100%',
    opacity: 0.5,
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .NewColor.Black */ .Wq.Black
  },
  root: {
    // @ts-ignore: (RNW CSS)
    position: 'fixed',
    top: '50%',
    left: '50%',
    zIndex: 999,
    maxWidth: '90%',
    maxHeight: '90%',
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .NewColor.White */ .Wq.White,
    paddingTop: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(12),
    paddingBottom: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(48),
    borderRadius: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(12),
    transform: [{
      // @ts-ignore: (RNW CSS)
      translateX: '-50%'
    }, {
      // @ts-ignore: (RNW CSS)
      translateY: '-50%'
    }]
  },
  navigationRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(12)
  },
  navigationRowLeftColumn: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  leftAdornment: {
    marginRight: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(6)
  },
  errorContainer: {
    paddingVertical: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(12),
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .NewColor.AccentRed */ .Wq.AccentRed
  },
  bodyRoot: {
    marginTop: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(12)
  }
});
var imageStyles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_14___default().create({
  backIcon: {
    width: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dpFromPx */ .rj.dpFromPx(24),
    height: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dpFromPx */ .rj.dpFromPx(24),
    tintColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .NewColor.Black */ .Wq.Black
  }
});

/***/ }),

/***/ 12970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ styles; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22120);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_native_web_dist_cjs_exports_TextInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64941);
/* harmony import */ var react_native_web_dist_cjs_exports_TextInput__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TextInput__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var TextInput = function TextInput(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_native_web_dist_cjs_exports_TextInput__WEBPACK_IMPORTED_MODULE_4___default()), _objectSpread(_objectSpread({
    placeholderTextColor: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .NewColor.DarkGray */ .Wq.DarkGray
  }, props), {}, {
    style: [
    /**
     * This color default is to support dark mode
     */
    src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.CMidnight */ .pn.CMidnight, src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.T16R */ .pn.T16R, props.multiline ? styles.multilineRoot : styles.root, props.style]
  }));
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5___default().create({
  root: {
    paddingHorizontal: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12),
    height: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dpFromPx */ .rj.dpFromPx(42),
    borderRadius: 3 * src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.Unit */ .rj.Unit,
    borderWidth: (react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5___default().hairlineWidth),
    borderColor: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .BrandColor.DarkGray */ .Te.DarkGray
  },
  multilineRoot: {
    paddingHorizontal: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12),
    paddingTop: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12),
    paddingBottom: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12),
    borderRadius: 3 * src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.Unit */ .rj.Unit,
    borderWidth: (react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5___default().hairlineWidth),
    borderColor: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .BrandColor.DarkGray */ .Te.DarkGray
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (TextInput);

/***/ }),

/***/ 61129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 4 modules
var Layout = __webpack_require__(66001);
// EXTERNAL MODULE: ./src/components/Text/index.tsx
var Text = __webpack_require__(71605);
// EXTERNAL MODULE: ./src/components/TextInput/index.tsx
var TextInput = __webpack_require__(12970);
// EXTERNAL MODULE: ./src/components/CardModal/index.tsx
var CardModal = __webpack_require__(6692);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(71862);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/components/LargeSingleSelect/context.ts

var SelectedIndexContext = /*#__PURE__*/react.createContext( // This is `undefined` and typecasted on purpose.
// See https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-382213106
undefined);
var OnSelectedIndexChangedContext = /*#__PURE__*/react.createContext(function () {});
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(TouchableOpacity);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/LargeSingleSelect/Button/index.tsx






var Button_Button = function Button(props) {
  var selectedIndex = react.useContext(SelectedIndexContext);
  var onSelectedIndexChanged = react.useContext(OnSelectedIndexChangedContext);
  var onPress = react.useCallback(function () {
    onSelectedIndexChanged(props.idx);
  }, [props.idx, onSelectedIndexChanged]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
    style: [styles.root, props.idx === selectedIndex && styles.selected],
    onPress: onPress,
    children: props.children
  });
};
var styles = StyleSheet_default().create({
  root: {
    borderRadius: constants/* Grid.dp */.rj.dp(16),
    paddingVertical: constants/* Grid.dp */.rj.dp(26),
    paddingHorizontal: constants/* Grid.dp */.rj.dp(16)
  },
  selected: {
    backgroundColor: constants/* Color.LightShade */.Il.LightShade
  }
});
;// CONCATENATED MODULE: ./src/components/LargeSingleSelect/Provider/index.tsx




var Provider = function Provider(props) {
  var _React$useState = react.useState(props.defaultSelectedIdx),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      selectedIndex = _React$useState2[0],
      setSelectedIndex = _React$useState2[1];

  react.useEffect(function () {
    if (props.onSelectedIdxChanged != null) {
      props.onSelectedIdxChanged(selectedIndex);
    }
  }, [selectedIndex, props.defaultSelectedIdx, props.onSelectedIdxChanged]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectedIndexContext.Provider, {
    value: selectedIndex,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(OnSelectedIndexChangedContext.Provider, {
      value: setSelectedIndex,
      children: props.children
    })
  });
};
;// CONCATENATED MODULE: ./src/components/LargeSingleSelect/index.ts


// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/views/auth/LoginScreen/LoginButton/AuthOptionStep/useLoginStartState.ts
/* provided dependency */ var process = __webpack_require__(83454);




var _FormattedError;




var PHONE_REGEX = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
var ErrorCode;

(function (ErrorCode) {
  ErrorCode[ErrorCode["PhoneNumberRequired"] = 0] = "PhoneNumberRequired";
  ErrorCode[ErrorCode["UnexpectedError"] = 1] = "UnexpectedError";
  ErrorCode[ErrorCode["InvalidPhoneNumber"] = 2] = "InvalidPhoneNumber";
  ErrorCode[ErrorCode["InvalidCountryCode"] = 3] = "InvalidCountryCode";
})(ErrorCode || (ErrorCode = {}));

var FormattedError = (_FormattedError = {}, (0,defineProperty/* default */.Z)(_FormattedError, ErrorCode.PhoneNumberRequired, 'A phone number is required to log in.'), (0,defineProperty/* default */.Z)(_FormattedError, ErrorCode.UnexpectedError, 'Something is wrong – please try again later.'), (0,defineProperty/* default */.Z)(_FormattedError, ErrorCode.InvalidPhoneNumber, 'That’s not a valid phone number.'), (0,defineProperty/* default */.Z)(_FormattedError, ErrorCode.InvalidCountryCode, 'That’s not a valid country code.'), _FormattedError);
var useLoginStartState = function useLoginStartState(args) {
  var router = (0,next_router.useRouter)();

  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      errorCode = _React$useState2[0],
      setErrorCode = _React$useState2[1];

  var debug = router.query['debug'] != null;
  var onNextPress = react.useCallback( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var loginResponse;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (PHONE_REGEX.test(args.phone)) {
              _context.next = 3;
              break;
            }

            setErrorCode(ErrorCode.InvalidPhoneNumber);
            return _context.abrupt("return");

          case 3:
            setErrorCode(null);
            _context.prev = 4;
            _context.next = 7;
            return fetch("https://api.porter.oneshop.com/api/business_manager/login/request", {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                countryCode: '+1',
                subscriberNumber: args.phone,
                debug: debug ? '1' : process.env.NEXT_PUBLIC_DEBUG === '1' ? '1' : undefined
              })
            });

          case 7:
            loginResponse = _context.sent;

            if (loginResponse.status === 200) {
              args.onSuccess();
            } else if (loginResponse.status === 404) {
              setErrorCode(ErrorCode.UnexpectedError);
            } else if (Math.floor(loginResponse.status / 100) === 4) {
              setErrorCode(ErrorCode.InvalidPhoneNumber);
            } else {
              setErrorCode(ErrorCode.UnexpectedError);
            }

            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            setErrorCode(ErrorCode.UnexpectedError);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  })), [args.phone, debug]);
  var onBackPress = react.useCallback(function () {
    setErrorCode(null);
    args.onBack();
  }, [args.onBack]);
  return {
    errorCode: errorCode,
    errorMessage: errorCode != null ? FormattedError[errorCode] : null,
    onNextPress: onNextPress,
    onBackPress: onBackPress
  };
};
;// CONCATENATED MODULE: ./src/views/auth/LoginScreen/LoginButton/AuthOptionStep/index.tsx












var AuthOptionStep = function AuthOptionStep(props) {
  var _loginStartState$erro;

  var loginStartState = useLoginStartState({
    phone: props.phone,
    onSuccess: props.onNext,
    onBack: props.onBack
  });
  var onNext = react.useCallback( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (props.method === 0) {
              loginStartState.onNextPress();
            } else {
              props.onNext();
            }

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [props.method, loginStartState.onNextPress]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardModal/* Header */.h4, {
      errorLabel: (_loginStartState$erro = loginStartState.errorMessage) !== null && _loginStartState$erro !== void 0 ? _loginStartState$erro : undefined,
      onNext: onNext,
      onBack: loginStartState.onBackPress
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CardModal/* Body */.uT, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T24B */.pn.T24B, constants/* GridStyle.MBUnit */.Hy.MBUnit],
        children: 'How do you want to log in?'
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Provider, {
        defaultSelectedIdx: props.method,
        onSelectedIdxChanged: props.onMethodChange,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button, {
          idx: 0,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            style: constants/* TextStyle.T16M */.pn.T16M,
            children: "Send a code to ".concat(props.phone)
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button, {
          idx: 1,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            style: constants/* TextStyle.T16M */.pn.T16M,
            children: 'Use your OneShop PIN code'
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var LoginButton_AuthOptionStep = (AuthOptionStep);
// EXTERNAL MODULE: ./src/clients/Network/index.tsx + 10 modules
var Network = __webpack_require__(21324);
// EXTERNAL MODULE: ./src/clients/SecureStore/index.ts
var SecureStore = __webpack_require__(6863);
;// CONCATENATED MODULE: ./src/views/auth/LoginScreen/LoginButton/OtpStep/useConfirmOtpState.ts




var useConfirmOtpState_FormattedError;





var useConfirmOtpState_ErrorCode;

(function (ErrorCode) {
  ErrorCode[ErrorCode["UnexpectedError"] = 0] = "UnexpectedError";
  ErrorCode[ErrorCode["NotRegistered"] = 1] = "NotRegistered";
  ErrorCode[ErrorCode["InvalidPhoneNumberOrToken"] = 2] = "InvalidPhoneNumberOrToken";
})(useConfirmOtpState_ErrorCode || (useConfirmOtpState_ErrorCode = {}));

var OtpStep_useConfirmOtpState_FormattedError = (useConfirmOtpState_FormattedError = {}, (0,defineProperty/* default */.Z)(useConfirmOtpState_FormattedError, useConfirmOtpState_ErrorCode.UnexpectedError, 'Either your code or phone number might be incorrect.'), (0,defineProperty/* default */.Z)(useConfirmOtpState_FormattedError, useConfirmOtpState_ErrorCode.NotRegistered, 'Not registered. Did you mean to sign up?'), (0,defineProperty/* default */.Z)(useConfirmOtpState_FormattedError, useConfirmOtpState_ErrorCode.InvalidPhoneNumberOrToken, 'Either your code or phone number is incorrect.'), useConfirmOtpState_FormattedError);
var useConfirmOtpState = function useConfirmOtpState(args) {
  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      errorCode = _React$useState2[0],
      setErrorCode = _React$useState2[1];

  var onNextPress = react.useCallback( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var response;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setErrorCode(null);
            _context.prev = 1;
            _context.next = 4;
            return Network/* http.fetch */.d.fetch('/api/business_manager/login/verify', {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                countryCode: '+1',
                subscriberNumber: args.phone,
                token: args.code
              })
            });

          case 4:
            response = _context.sent;

            if (response.status === 200) {
              setTimeout(function () {
                var _secureStore$xSpBI;

                var secureStore = SecureStore/* get */.U2([SecureStore/* Key.BusinessManagerId */.sr.BusinessManagerId, SecureStore/* Key.BusinessId */.sr.BusinessId]);
                var businessId = (_secureStore$xSpBI = secureStore['x-sp-b-id']) !== null && _secureStore$xSpBI !== void 0 ? _secureStore$xSpBI : null;

                try {
                  // @ts-ignore
                  if (window.fbq != null && businessId != null) {
                    // @ts-ignore
                    window.fbq('init', '752587695479733', {
                      ph: "1".concat(args.phone),
                      external_id: businessId
                    });
                  }
                } catch (err) {
                  console.error(err);
                }

                try {
                  // @ts-ignore
                  if (window.gtag != null) {
                    if (businessId != null) {
                      // @ts-ignore
                      window.gtag('config', 'GTM-KRX8Z9W', {
                        user_id: businessId
                      });
                    } // @ts-ignore


                    window.gtag('event', 'login');
                  }
                } catch (err) {
                  console.error(err);
                }
              }, 30);
              args.onSuccess();
            } else if (response.status === 404) {
              setErrorCode(useConfirmOtpState_ErrorCode.NotRegistered);
            } else if (response.status === 401 || response.status === 205) {
              setErrorCode(useConfirmOtpState_ErrorCode.InvalidPhoneNumberOrToken);
            } else {
              setErrorCode(useConfirmOtpState_ErrorCode.UnexpectedError);
            }

            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            setErrorCode(useConfirmOtpState_ErrorCode.UnexpectedError);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  })), [args.phone, args.code, args.onSuccess]);
  var onBackPress = react.useCallback(function () {
    setErrorCode(null);
    args.onBack();
  }, [args.onBack]);
  return {
    errorCode: errorCode,
    errorMessage: errorCode != null ? OtpStep_useConfirmOtpState_FormattedError[errorCode] : null,
    onNextPress: onNextPress,
    onBackPress: onBackPress
  };
};
;// CONCATENATED MODULE: ./src/views/auth/LoginScreen/LoginButton/OtpStep/index.tsx











var OtpStep = function OtpStep(props) {
  var _confirmOtpState$erro;

  var _React$useState = react.useState(''),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      code = _React$useState2[0],
      setCode = _React$useState2[1];

  var confirmOtpState = useConfirmOtpState({
    phone: props.phone,
    code: code,
    onSuccess: props.onSuccess,
    onBack: props.onBack
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardModal/* Header */.h4, {
      errorLabel: (_confirmOtpState$erro = confirmOtpState.errorMessage) !== null && _confirmOtpState$erro !== void 0 ? _confirmOtpState$erro : undefined,
      onNext: confirmOtpState.onNextPress,
      onBack: confirmOtpState.onBackPress
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CardModal/* Body */.uT, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: constants/* TextStyle.T24B */.pn.T24B,
        children: 'One-time code'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T16R */.pn.T16R, constants/* TextStyle.CDarkGray */.pn.CDarkGray, constants/* GridStyle.MBUnit */.Hy.MBUnit],
        children: "We sent a code to ".concat(props.phone)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        autoFocus: true,
        autoComplete: "tel",
        style: constants/* TextStyle.T16R */.pn.T16R,
        placeholder: "Code",
        keyboardType: "number-pad",
        textContentType: "oneTimeCode",
        onChangeText: setCode,
        maxLength: 6
      })]
    })]
  });
};

/* harmony default export */ var LoginButton_OtpStep = (OtpStep);
;// CONCATENATED MODULE: ./src/views/auth/LoginScreen/LoginButton/PinStep/useConfirmPinState.ts




var useConfirmPinState_FormattedError;





var useConfirmPinState_ErrorCode;

(function (ErrorCode) {
  ErrorCode[ErrorCode["UnexpectedError"] = 0] = "UnexpectedError";
  ErrorCode[ErrorCode["NotRegistered"] = 1] = "NotRegistered";
  ErrorCode[ErrorCode["InvalidPhoneNumberOrToken"] = 2] = "InvalidPhoneNumberOrToken";
})(useConfirmPinState_ErrorCode || (useConfirmPinState_ErrorCode = {}));

var PinStep_useConfirmPinState_FormattedError = (useConfirmPinState_FormattedError = {}, (0,defineProperty/* default */.Z)(useConfirmPinState_FormattedError, useConfirmPinState_ErrorCode.UnexpectedError, 'Either your code or phone number might be incorrect.'), (0,defineProperty/* default */.Z)(useConfirmPinState_FormattedError, useConfirmPinState_ErrorCode.NotRegistered, 'Not registered. Did you mean to sign up?'), (0,defineProperty/* default */.Z)(useConfirmPinState_FormattedError, useConfirmPinState_ErrorCode.InvalidPhoneNumberOrToken, 'Either your code or phone number is incorrect.'), useConfirmPinState_FormattedError);
var useConfirmPinState = function useConfirmPinState(args) {
  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      errorCode = _React$useState2[0],
      setErrorCode = _React$useState2[1];

  var onNextPress = react.useCallback( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var response;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setErrorCode(null);
            _context.prev = 1;
            _context.next = 4;
            return Network/* http.fetch */.d.fetch('/api/business_manager/login/verify', {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                countryCode: '+1',
                subscriberNumber: args.phone,
                pin: args.code
              })
            });

          case 4:
            response = _context.sent;

            if (response.status === 200) {
              setTimeout(function () {
                var _secureStore$xSpBI;

                var secureStore = SecureStore/* get */.U2([SecureStore/* Key.BusinessManagerId */.sr.BusinessManagerId, SecureStore/* Key.BusinessId */.sr.BusinessId]);
                var businessId = (_secureStore$xSpBI = secureStore['x-sp-b-id']) !== null && _secureStore$xSpBI !== void 0 ? _secureStore$xSpBI : null;

                try {
                  // @ts-ignore
                  if (window.fbq != null && businessId != null) {
                    // @ts-ignore
                    window.fbq('init', '752587695479733', {
                      ph: "1".concat(args.phone),
                      external_id: businessId
                    });
                  }
                } catch (err) {
                  console.error(err);
                }

                try {
                  // @ts-ignore
                  if (window.gtag != null) {
                    if (businessId != null) {
                      // @ts-ignore
                      window.gtag('config', 'GTM-KRX8Z9W', {
                        user_id: businessId
                      });
                    } // @ts-ignore


                    window.gtag('event', 'login');
                  }
                } catch (err) {
                  console.error(err);
                }
              }, 30);
              args.onSuccess();
            } else if (response.status === 404) {
              setErrorCode(useConfirmPinState_ErrorCode.NotRegistered);
            } else if (response.status === 401 || response.status === 205) {
              setErrorCode(useConfirmPinState_ErrorCode.InvalidPhoneNumberOrToken);
            } else {
              setErrorCode(useConfirmPinState_ErrorCode.UnexpectedError);
            }

            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            setErrorCode(useConfirmPinState_ErrorCode.UnexpectedError);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  })), [args.phone, args.code, args.onSuccess]);
  var onBackPress = react.useCallback(function () {
    setErrorCode(null);
    args.onBack();
  }, [args.onBack]);
  return {
    errorCode: errorCode,
    errorMessage: errorCode != null ? PinStep_useConfirmPinState_FormattedError[errorCode] : null,
    onNextPress: onNextPress,
    onBackPress: onBackPress
  };
};
;// CONCATENATED MODULE: ./src/views/auth/LoginScreen/LoginButton/PinStep/index.tsx











var PinStep = function PinStep(props) {
  var _confirmPinState$erro;

  var _React$useState = react.useState(''),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      code = _React$useState2[0],
      setCode = _React$useState2[1];

  var confirmPinState = useConfirmPinState({
    phone: props.phone,
    code: code,
    onSuccess: props.onSuccess,
    onBack: props.onBack
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardModal/* Header */.h4, {
      errorLabel: (_confirmPinState$erro = confirmPinState.errorMessage) !== null && _confirmPinState$erro !== void 0 ? _confirmPinState$erro : undefined,
      onNext: confirmPinState.onNextPress,
      onBack: confirmPinState.onBackPress
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CardModal/* Body */.uT, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: constants/* TextStyle.T24B */.pn.T24B,
        children: '6-digit PIN code'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T16R */.pn.T16R, constants/* TextStyle.CDarkGray */.pn.CDarkGray, constants/* GridStyle.MBUnit */.Hy.MBUnit],
        children: "If you already set up a OneShop PIN code for ".concat(props.phone, ", you can use it to log in here.")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        autoFocus: true,
        autoComplete: "tel",
        style: constants/* TextStyle.T16R */.pn.T16R,
        placeholder: "Code",
        keyboardType: "number-pad",
        textContentType: "oneTimeCode",
        onChangeText: setCode,
        maxLength: 6
      })]
    })]
  });
};

/* harmony default export */ var LoginButton_PinStep = (PinStep);
;// CONCATENATED MODULE: ./src/views/auth/LoginScreen/LoginButton/index.tsx














var LoginButton = function LoginButton(props) {
  var router = (0,next_router.useRouter)();

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      modalOpen = _React$useState2[0],
      setModalOpen = _React$useState2[1];

  var _React$useState3 = react.useState(0),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      step = _React$useState4[0],
      setStep = _React$useState4[1];

  var _React$useState5 = react.useState(0),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      method = _React$useState6[0],
      setMethod = _React$useState6[1];

  var onLoginPress = react.useCallback(function () {
    setStep(0);
    setModalOpen(true);
  }, []);
  var onNextPress = react.useCallback(function () {
    if (step >= 1) {
      router.push(props.redirectUrl != null ? decodeURIComponent(props.redirectUrl) : '/u/settings');
    } else {
      setStep(function (step) {
        return step + 1;
      });
    }
  }, [step, props.redirectUrl]);
  var onBackPress = react.useCallback(function () {
    setStep(function (step) {
      return step - 1;
    });
  }, []);
  react.useEffect(function () {
    if (step < 0 || step > 1) {
      setModalOpen(false);
    }
  }, [step]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      disabled: props.phone.length !== 10,
      type: "secondary",
      onPress: onLoginPress,
      children: 'Log in'
    }), modalOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardModal/* Portal */.h_, {
      style: LoginButton_styles.cardModal,
      children: step === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoginButton_AuthOptionStep, {
        phone: props.phone,
        method: method,
        onMethodChange: setMethod,
        onNext: onNextPress,
        onBack: onBackPress
      }) : step === 1 ? method === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoginButton_OtpStep, {
        phone: props.phone,
        onSuccess: onNextPress,
        onBack: onBackPress
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LoginButton_PinStep, {
        phone: props.phone,
        onSuccess: onNextPress,
        onBack: onBackPress
      }) : null
    }) : null]
  });
};

var LoginButton_styles = StyleSheet_default().create({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    width: constants/* Grid.dp */.rj.dp(480),
    maxWidth: '100%'
  },
  logoImage: {
    width: constants/* Grid.dp */.rj.dp(175),
    height: constants/* Grid.dp */.rj.dp(36)
  },
  actionRow: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between'
  },
  cardModal: {
    width: constants/* Grid.dp */.rj.dp(480)
  }
});
/* harmony default export */ var LoginScreen_LoginButton = (LoginButton);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Image/index.js
var Image = __webpack_require__(94965);
var Image_default = /*#__PURE__*/__webpack_require__.n(Image);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
;// CONCATENATED MODULE: ./src/views/auth/LoginScreen/index.tsx














var LoginScreen = function LoginScreen() {
  var _React$useState = react.useState(''),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      phone = _React$useState2[0],
      setPhone = _React$useState2[1];

  var router = (0,next_router.useRouter)();
  var redirectUrl = Array.isArray(router.query.redirect) ? router.query.redirect[0] : router.query.redirect;
  var logoImageSource = react.useMemo(function () {
    return {
      uri: '/static/images/app/logo-login.png?v=1',
      width: constants/* Grid.dp */.rj.dp(176),
      height: constants/* Grid.dp */.rj.dp(36)
    };
  }, []);
  var onChangePhoneText = react.useCallback(function (text) {
    setPhone(text.replace(/[^0-9]/g, ''));
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: LoginScreen_styles.root,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* EdgeGutter */.MX, {
      style: LoginScreen_styles.card,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: constants/* GridStyle.MB2Unit */.Hy.MB2Unit,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((Image_default()), {
          source: logoImageSource,
          width: constants/* Grid.dp */.rj.dp(175),
          height: constants/* Grid.dp */.rj.dp(36),
          style: LoginScreen_styles.logoImage,
          resizeMode: "contain"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: constants/* GridStyle.MB2Unit */.Hy.MB2Unit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          style: [constants/* TextStyle.T16B */.pn.T16B, constants/* GridStyle.MB2Unit */.Hy.MB2Unit],
          children: 'Welcome back! Log in to your existing OneShop account.'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          style: [constants/* TextStyle.T12M */.pn.T12M, constants/* GridStyle.MBUnit */.Hy.MBUnit],
          children: 'Mobile phone number'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
          autoFocus: true,
          autoComplete: "tel",
          style: constants/* TextStyle.T16R */.pn.T16R,
          placeholder: "Your phone number",
          keyboardType: "number-pad",
          textContentType: "telephoneNumber",
          value: phone,
          onChangeText: onChangePhoneText,
          maxLength: '(XXX) XXX-XXXX'.length
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LoginScreen_LoginButton, {
        phone: phone,
        redirectUrl: redirectUrl
      })]
    })
  });
};

var LoginScreen_styles = StyleSheet_default().create({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    width: constants/* Grid.dp */.rj.dp(360),
    maxWidth: '100%'
  },
  logoImage: {
    width: constants/* Grid.dp */.rj.dp(175),
    height: constants/* Grid.dp */.rj.dp(36)
  },
  actionRow: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between'
  },
  cardModal: {
    width: constants/* Grid.dp */.rj.dp(480)
  }
});
/* harmony default export */ var auth_LoginScreen = (LoginScreen);
;// CONCATENATED MODULE: ./src/pages/login.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Login | OneShop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image')]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(auth_LoginScreen, {})]
  });
}

/***/ }),

/***/ 83236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(61129);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,4965,9561,1776,6554,858,9774,2888,179], function() { return __webpack_exec__(83236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);